// Custome code 
    $('.wrp-gift-sets-bundle input[type="radio"]').change(function() {
      // console.log("this-variant-price", $(this).attr("variant-price"));
      var currvarid = $(this).attr("variant-id");
      var selected_vai_price = $(this).attr("variant-price");
      $('.default-product input[type="checkbox"]').attr("value", currvarid);
      var attributeValue = parseInt($(this).attr('gift-pro-limit'), 10);
      $(".data-checkbox-limit").attr("data-checkbox-limit", attributeValue);
      $('.wrp-gift-sets-bundle .col-pro-list input[type="checkbox"]').prop("checked", false);
      $(".wrp-gift-sets-bundle #basket-price").text(selected_vai_price);
      updateRemaining();
    }); 

if ($(".wrp-gift-sets-bundle ").length > 0){
       updateRemaining()
}
;
// slick slider
$('.wrp-gift-sets-bundle .slider-wrp, .master-wrp-bundle .slider-wrp').slick({
  infinite: true,
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true
});
